var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.919 12.32a1.1 1.1 0 00-.32.97l.89 4.92a1.08 1.08 0 01-.45 1.08 1.1 1.1 0 01-1.17.08l-4.43-2.31a1.13 1.13 0 00-.5-.131h-.27a.812.812 0 00-.27.09l-4.43 2.321c-.22.11-.467.149-.71.11a1.112 1.112 0 01-.89-1.271l.89-4.92a1.119 1.119 0 00-.32-.979L.33 8.78a1.08 1.08 0 01-.27-1.13c.135-.396.477-.685.89-.75l4.97-.721c.378-.039.71-.269.88-.609l2.19-4.49c.052-.1.119-.192.2-.27l.09-.07a.671.671 0 01.16-.13l.11-.04.17-.07h.42c.377.039.708.264.88.6l2.22 4.47c.16.327.47.554.83.609l4.97.721c.42.06.77.35.91.75.13.401.018.841-.29 1.13l-3.74 3.54z",
    fill: "#ED1B2E"
  })));
}

export default SvgStar;